export type Tenant = 'internal' | 'external';

export const getProviderUserObjectId = (tenant: Tenant, claims?: {oid?: string, sub?: string}): string | undefined =>
    claims && (tenant === 'internal' ? claims.oid : claims.sub || claims.oid);

export const isValidUserObjectId = (value?: string): boolean =>
    !!value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value) && value !== '00000000-0000-0000-0000-000000000000';

export const INTERNAL_ROLES = ['ADMINISTRATOR', 'PUBLISHER', 'EEOHANDLER', 'READER'];
export const EXTERNAL_ROLES = ['READER', 'APPROVER', 'SUPPLIER'];

export interface MeProjectRoles {
    tenant: Tenant;
    isSuperAdmin: boolean;
    company: string | null;
    projects: { projectId: number; projectCodeword: string; projectNumber?: string | null; roles: string[] }[];
}

export interface ProjectUser {
    projectUserRoleId: number;
    projectId: number;
    exodUserId: number;
    tenant: Tenant;
    userObjectId: string;
    email?: string | null;
    displayName?: string | null;
    company?: string | null;
    lastKnownCompany?: string | null;
    lastLoginAt?: string | null;
    roleCode: string;
    source: string;
    createdAt: string;
    createdBy: string;
    isDeleted: boolean;
    deletedAt?: string | null;
    deletedBy?: string | null;
}

export interface AddProjectUser {
    tenant: Tenant;
    userObjectId: string;
    roleCode: string;
    email?: string;
    displayName?: string;
    company?: string;
}

export const isInternalSuperAdmin = (me?: MeProjectRoles): boolean =>
    !!me && me.tenant === 'internal' && me.isSuperAdmin;

export const getProjectRoleCodes = (me: MeProjectRoles | undefined, projectId: number | undefined): string[] => {
    if (!me || projectId === undefined) return [];
    const project = me.projects.find(item => item.projectId === projectId);
    const allowed = me.tenant === 'internal' ? INTERNAL_ROLES : EXTERNAL_ROLES;
    return project ? project.roles.filter(role => allowed.includes(role)) : [];
};

export const canManageProjectUsers = (me: MeProjectRoles | undefined, projectId: number | undefined): boolean =>
    isInternalSuperAdmin(me) || (!!me && me.tenant === 'internal' && getProjectRoleCodes(me, projectId).includes('ADMINISTRATOR'));